module.exports = __webpack_public_path__ + "img/hm_block01_02_en.94d6823b.png";